import * as React from 'react'
import { OnboardingComponentProps } from '.'

export const RedirectComponent: React.FC<OnboardingComponentProps> = ({
  link,
}) => {
    React.useEffect(() => {
    // Re-routing to payments landing page
    window.location.assign(link)
  }, [link])

  return null
}